import { ISOCountryCode, parseCountryCode } from '@pmi.web/countries';
import { SupportedLanguage } from '@pmi.web/localization';

import { au } from './au';
import { ca } from './ca';
import { defaultFormatter } from './default';
import { jp } from './jp';
import { us } from './us';
import { IAddress } from '../../types/IAddress';

export function formatAddressSuggestion(address: IAddress): string {
  const addressDetails: string[] = [];

  if (address.addressLine1) {
    addressDetails.push(address.addressLine1);
  }

  if (address.addressLine2) {
    addressDetails.push(address.addressLine2);
  }

  if (address.locality || address.zip) {
    addressDetails.push(
      `${address.zip ?? ''} ${address.locality ?? ''}`.trim(),
    );
  }

  if (address.administrativeDistrictLevel1) {
    addressDetails.push(address.administrativeDistrictLevel1);
  }

  if (address.administrativeDistrictLevel2) {
    addressDetails.push(address.administrativeDistrictLevel2);
  }

  if (address.administrativeDistrictLevel3) {
    addressDetails.push(address.administrativeDistrictLevel3);
  }

  return addressDetails.join(', ');
}

export function formatAddress(
  address: IAddress,
  language: SupportedLanguage = SupportedLanguage.English,
): string {
  const addressCountry = address.country
    ? parseCountryCode(address.country)
    : undefined;

  if (!address) {
    return '';
  }

  if (!addressCountry) {
    return defaultFormatter(address, language);
  }

  if (addressCountry === ISOCountryCode.Australia) {
    return au(address, language);
  }

  if (addressCountry === ISOCountryCode.Japan) {
    return jp(address, language);
  }

  if (addressCountry === ISOCountryCode.UnitedStatesAmerica) {
    return us(address, language);
  }

  if (addressCountry === ISOCountryCode.Canada) {
    return ca(address, language);
  }

  return defaultFormatter(address, language);
}
